import { jsx } from "react/jsx-runtime";
import { forwardRef, cloneElement } from "react";
import PropTypes from "prop-types";
import { pipe, replace, mapKeys, keys } from "lodash/fp";
import { kebabCase } from "change-case";
import { IconWrapper } from "./icon.styles.es.js";
import * as index from "../../icons/index.es.js";
const toTypeKey = pipe(replace(/Icon$/, ""), kebabCase);
const iconMap = mapKeys(toTypeKey, index);
const iconTypes = keys(iconMap);
const propTypes = {
  animation: PropTypes.oneOf(["none", "rotate"]),
  children: PropTypes.node,
  color: PropTypes.string,
  display: PropTypes.string,
  magnitude: PropTypes.oneOf([
    "xsmall",
    "small",
    "medium",
    "large",
    "xlarge",
    "xxlarge"
  ]),
  opacity: PropTypes.number,
  transform: PropTypes.string,
  transitionDuration: PropTypes.number,
  type: PropTypes.oneOf(["custom", ...iconTypes]).isRequired
};
const defaultProps = {
  animation: "none",
  children: void 0,
  color: void 0,
  display: "block",
  magnitude: void 0,
  opacity: void 0,
  transform: void 0,
  transitionDuration: void 0
};
const Icon = forwardRef(
  ({
    animation,
    children,
    color,
    display,
    magnitude,
    opacity,
    transform,
    transitionDuration,
    type,
    ...restProps
  }, ref) => {
    const Component = iconMap[type];
    const size = {
      xsmall: 12,
      small: 16,
      medium: 20,
      large: 24,
      xlarge: 32,
      xxlarge: 64
    }[magnitude] || "1em";
    const svgProps = {
      display,
      fill: color,
      height: size,
      opacity,
      pointerEvents: "none",
      width: size
    };
    return /* @__PURE__ */ jsx(
      IconWrapper,
      {
        ref,
        role: "img",
        $animation: animation,
        $color: color,
        $display: display,
        $transform: transform,
        $transitionDuration: transitionDuration,
        ...restProps,
        children: type === "custom" ? cloneElement(children, svgProps) : /* @__PURE__ */ jsx(Component, { ...svgProps })
      }
    );
  }
);
Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;
export {
  Icon
};
